<template>
  <base-section id="theme-features">
    <base-section-heading title="Especialidades">
      Nuestro equipo de profesionales y especialistas, con amplia experiencia en el sector, nos permiten la realización de todo tipo de obras e instalaciones de forma integral, desde su fase inicial.
    </base-section-heading>

    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          >
            {{ feature.description }}
          </base-avatar-card>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          title: 'Cargadores Eléctricos',
          color: 'primary',
          dark: true,
          img: 'icono_cargador.svg',
          description: 'El inversor de carga de vehículos SolarEdge es compatible con la conectividad de red y se integra perfectamente con la plataforma de monitorización.',
        },
        {
          title: 'Instalaciones Fotovoltáicas',
          color: 'primary',
          dark: true,
          img: 'icono_fotovoltaica.svg',
          description: 'ROSMAR ofrece un servicio integral para que puedas generar y consumir tu propia energía, en la que todo está pensado en términos de eficiencia y comodidad.',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Instalaciones Eléctricas',
          img: 'icono_electricidad.svg',
          description: 'Contamos con los medios técnicos y humanos más eficientes para acometer los mayores retos. Nuestra dilatada experiencia y nuestros clientes satisfechos nos avalan.',
        },
        {
          title: 'Redes de Datos Certificadas',
          color: 'primary',
          dark: true,
          icon: 'mdi-cable-data',
          description: 'Somos especialistas en instalaciones certificadas de redes de datos para los requerimientos más exigentes. Cat 6, fibra óptica, Armarios Rack, ...',
        },
        {
          title: 'Contraincendios',
          color: 'primary',
          dark: true,
          icon: 'mdi-fire',
          description: 'Empresa certificada para la instalación y mantenimiento de sistemas de protección contra-incendios.',
        },
        {
          title: 'Mantenimiento Preventivo',
          color: 'primary',
          dark: true,
          icon: 'mdi-hammer-screwdriver',
          description: 'Blindamos de garantía las instalaciones, sistemas, maquinaria y equipos que llevamos a cabo. La seguridad es lo primero.',
        },
      ],
    }),
  }
</script>
